import { CommonModule } from '@angular/common'
import { Component, inject } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import { ButtonModule } from 'src/app/components/button/button.module'
import { IIframeDialogOptions } from 'src/app/core/interfaces/modal.interface'
import { LogService } from 'src/app/core/services/log.service'


@Component({
  selector: 'iframe-dialog-component',
  template: `
    <div mat-dialog-title class="title">
      <span data-testid="title" i18n="@@finance.iframe-title">Apply for Financing</span>
      <div class="close-button-wrapper">
        <button mat-icon-button (click)="confirmClose()" aria-label="Close dialog" i18n-aria-label="@@asset-details.close-button.aria-label">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    <iframe [src]="sanitizedSrc" frameborder="0"></iframe>
  `,
  styleUrls: ['../../../../assets/admin.scss'],
  styles: [`
    @use "sass:map";
    @import 'src/assets/colors';
    @import 'src/assets/mixins';
    @property --iframe-dialog-outline-color {
      syntax: '<color>';
      inherits: true;
      initial-value: map.get($light, other, divider);
    }

    :host {
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;
    }

    iframe {
      width: 100%;
      height: 100%;
    }

    .title {
      @include mq(medium) {
        border-bottom: 1px solid var(--iframe-dialog-outline-color);
      }
    }
  `],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    ButtonModule,
  ],
})
export class IframeDialogComponent {
  private _logger = inject(LogService)
  private _sanitizer = inject(DomSanitizer)
  private _dialogRef = inject(MatDialogRef<IframeDialogComponent>)
  data = inject<IIframeDialogOptions>(MAT_DIALOG_DATA)

  sanitizedSrc!: SafeResourceUrl

  constructor() {
    try {
      const url = new URL(this.data.src)
      if (!['https:', 'http:'].includes(url.protocol)) {
        throw new Error('Invalid protocol')
      }
      // Sanitize for iframe use
      this.sanitizedSrc = this._sanitizer.bypassSecurityTrustResourceUrl(url.toString()) as SafeResourceUrl
    } catch (e) {
      this._logger.error('Error initializing IframeDialogComponent:', e)
      throw e
    }
  }

  confirmClose() {
    return confirm($localize`:@@finance.confirm-close:Are you sure you want to close this modal?`) ? this.closeDialog() : false
  }

  closeDialog(): void {
    this._dialogRef.close()
  }
}
